import { Reveal } from "@/components/Reveal";
import { Layers, Wind, Sofa, Droplets, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    icon: Layers,
    title: "Carpet Cleaning",
    desc: "Deep hot-water extraction that lifts embedded dirt and traffic marks, leaving carpets soft, bright and fresh.",
  },
  {
    icon: Wind,
    title: "Rug Cleaning",
    desc: "Gentle, fibre-safe cleaning for wool and delicate rugs — colours revived and textures restored.",
  },
  {
    icon: Sofa,
    title: "Couch / Upholstery",
    desc: "Sofas, chairs and upholstery cleaned thoroughly to remove grime, odours and everyday build-up.",
  },
  {
    icon: Droplets,
    title: "Stain Removal",
    desc: "Targeted treatment for stubborn spills, marks and set-in stains that ordinary cleaning leaves behind.",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-turquoise">
          What we do
        </p>
        <h2 className="mt-3 font-display fluid-h2 font-semibold text-navy">
          Cleaning services that leave{" "}
          <span className="italic text-turquoise">everything fresh</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08}>
            <div
              data-testid={`service-card-${i}`}
              className="group relative h-full overflow-hidden rounded-3xl bg-white p-7 ring-1 ring-navy/10 shadow-sm transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-navy/10 hover:ring-turquoise/40"
            >
              <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-turquoise-soft/40 transition-all duration-500 group-hover:scale-150" />
              <div className="relative">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-navy text-white transition-colors duration-500 group-hover:bg-turquoise">
                  <s.icon className="h-6 w-6" />
                </div>
                <div className="mt-6 flex items-start justify-between gap-2">
                  <h3 className="font-display text-2xl text-navy">{s.title}</h3>
                  <ArrowUpRight className="h-5 w-5 text-navy/30 transition-all duration-300 group-hover:text-turquoise group-hover:rotate-12" />
                </div>
                <p className="mt-3 text-sm leading-relaxed text-navy/65">{s.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
